"use client";

export default function HR() {
    return (
        <hr className="my-6 border-base text-center after:inline after:text-center after:text-sm after:content-['﹡﹡﹡']" />
    );
}
